import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionGenderPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionGender.heading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionGender.button1'),
          value: 'female',
        },
        {
          text: t('pages.onboarding.v1.questionGender.button2'),
          value: 'male',
        },
        {
          text: t('pages.onboarding.v1.questionGender.button3'),
          value: 'non-binary',
        },
      ]}
      onSubmit={handleSubmit}
      withLogin={!window.ReactNativeWebView}
    />
  )
}
